import script from "./IntellectualsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntellectualsPage.vue?vue&type=script&setup=true&lang=js"

import "./IntellectualsPage.vue?vue&type=style&index=0&id=4dd99294&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd99294"]])

export default __exports__